import { render, staticRenderFns } from "./NewBlindAddress.vue?vue&type=template&id=1f04dab2&"
import script from "./NewBlindAddress.vue?vue&type=script&lang=js&"
export * from "./NewBlindAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports